import { useApp } from '../../context/AppContext';
import { getStatusConfig } from '../../utils/helpers';
import type { TaskStatus } from '../../types';

const statusOrder: TaskStatus[] = ['backlog', 'todo', 'in_progress', 'in_review', 'done'];

export default function TaskDistribution() {
  const { state } = useApp();
  const { tasks } = state;

  const distribution = statusOrder.map((status) => {
    const count = tasks.filter((t) => t.status === status).length;
    const config = getStatusConfig(status);
    return { status, count, ...config };
  });

  const maxCount = Math.max(...distribution.map((d) => d.count), 1);

  const priorityDist = [
    { label: 'Crítica', count: tasks.filter((t) => t.priority === 'critical').length, color: '#ef4444' },
    { label: 'Alta', count: tasks.filter((t) => t.priority === 'high').length, color: '#f97316' },
    { label: 'Média', count: tasks.filter((t) => t.priority === 'medium').length, color: '#f59e0b' },
    { label: 'Baixa', count: tasks.filter((t) => t.priority === 'low').length, color: '#94a3b8' },
  ];

  const totalTasks = tasks.length || 1;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="bg-white rounded-2xl border border-slate-200 p-4 md:p-5">
        <h3 className="text-sm font-semibold text-slate-700 mb-4">Tarefas por Status</h3>
        <div className="space-y-3">
          {distribution.map((item) => (
            <div key={item.status}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium text-slate-600">{item.label}</span>
                <span className="text-xs font-semibold text-slate-700">{item.count}</span>
              </div>
              <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-700 ease-out"
                  style={{
                    width: `${(item.count / maxCount) * 100}%`,
                    backgroundColor: item.accent,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 p-4 md:p-5">
        <h3 className="text-sm font-semibold text-slate-700 mb-4">Tarefas por Prioridade</h3>
        <div className="flex items-end gap-3 h-40 mb-3">
          {priorityDist.map((item) => (
            <div key={item.label} className="flex-1 flex flex-col items-center gap-1">
              <span className="text-xs font-semibold text-slate-700">{item.count}</span>
              <div className="w-full relative" style={{ height: '100%' }}>
                <div
                  className="absolute bottom-0 w-full rounded-t-lg transition-all duration-700 ease-out"
                  style={{
                    height: `${Math.max((item.count / totalTasks) * 100, 4)}%`,
                    backgroundColor: item.color,
                    opacity: 0.8,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="flex gap-3">
          {priorityDist.map((item) => (
            <div key={item.label} className="flex-1 text-center">
              <div className="flex items-center justify-center gap-1">
                <div
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: item.color }}
                />
                <span className="text-[10px] text-slate-500">{item.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
